
export default class AppHeaderElement extends HTMLElement {
    constructor(){
        super();
    }

    connectedCallback() {
        
    }
}

customElements.define('app-header', AppHeaderElement);